import { render, staticRenderFns } from "./Edicao.vue?vue&type=template&id=fc400d7a"
import script from "./Edicao.vue?vue&type=script&lang=js"
export * from "./Edicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports